import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.375rem',
    width: 'fit-content',
    '&__radio': {
      appearance: 'none',
      MozAppearance: 'none',
      WebkitAppearance: 'none',
      width: '18px',
      height: '18px',
      borderRadius: '50%',
      border: `1px solid ${theme.value.colors.primary.main}`,
      position: 'relative',
      cursor: 'pointer',
    },
    '&:not(&--checked) &__radio:hover': {
      borderColor: theme.value.colors.primary.light1,
    },
    '&--checked &__radio::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '10px',
      height: '10px',
      background: theme.value.colors.primary.main,
      borderRadius: '50%',
    },
    '&--label-left &__radio': {
      order: 1,
    },
    '&__label': {
      fontFamily: theme.value.typography.fontFamily,
      color: theme.value.typography.color,
      fontSize: '1rem',
      fontWeight: theme.value.typography.fontWeight.regular,
      lineHeight: '1.375rem',
    },
    '&--disabled &__radio': {
      cursor: 'not-allowed',
    },
    '&--disabled &__radio, &--disabled:not(&--checked):hover &__radio': {
      borderColor: theme.value.colors.gray.medium2,
    },
    '&--disabled &__radio::after': {
      background: theme.value.colors.gray.medium2,
    },
    '&--disabled &__label': {
      color: theme.value.colors.gray.medium2,
    },
  }));

  return baseClass;
};
